import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Overlay, Popover, Modal, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { Formik, Form } from "formik";
import FormikControl from "../../../layouts/Input/FormikControl";
import { getDropdownList,getDropdownListByPost } from "../../Shared/dropdownListActions";
import axios from "../../../apis/Api";
import { renderCell, renderHeader } from "../../../utilities/FUNCTIONS";
import TransactionalDataFileTemplate from "../../../assets/Templates/TransactionalDataTemplate.xlsx";
import {
  GET_DISTRIBUTOR_DDL,
  GET_DISTRIBUTIONCENTER_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
  GET_JOBS_DISTRIBUTOR_DDL,
  GET_BANKS
} from "../../../Types";
import { toast } from "react-toastify";
import { getExcelSize, MAX_FILE_SIZE_MB } from "../../../utilities/FUNCTIONS";
import history from "../../../history";
import * as Yup from "yup";
import { addTransactionalSheet, getTransactionalData, downloadJob } from "./ShopTransactionalDataActions";
import Moment from "react-moment";
import storage from "../../../apis/Storage";
import { isPermittedPage } from "../../../apis/Utility";
import { formatDate } from "../../../utilities/FUNCTIONS";
import ExcelIcon from "../../../assets/Images/Distributors/excel-icon.png";
import { AlignEnd } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom";

const ShopTransactionalData = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));
  const history = useHistory();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const [jobModalShow, setJobModalShow] = useState(false);
  const [dataSheetSelectedFile, setDataSheetSelectedFile] = useState(null);

  const [addJobDistributorName, setAddJobDistributorName] = useState(null);
  const [addJobDistributionCenter, setAddJobDistributionCenter] = useState(null);

  const [addOrderDistributionCentersOptions, setAddOrderDistributionCentersOptions] = useState(null);
  const [filterDistributionCentersOptions, setFilterDistributionCentersOptions] = useState(null);

  const [filterDistributorName, setFilterDistributorName] = useState(null);
  const [filterDistributionID, setFilterDistributionID] = useState(null);
    const [bankNameValue, setBankNameValue] = useState(null);

  const [addJobModalInitialValue, setAddJobModalInitialValue] = useState({
    distributorName: "",
    distributionCenter: "",
    bankname:"",
    jobDataFile: null,
  });

  const [filter, setfilter] = useState({
    distributorId: null,
    distCenterId: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: null,
    isExport: false,
  });

  const addJobFormValidationSchema = Yup.object().shape({
    distributorName: Yup.string().required("Distributor Name is required"),
    distributionCenter: Yup.string().required("Distribution Center is required"),
  });

  const [addJobDistributorsOptions, setAddJobDistributorsOptions] = useState(null);
  const [addJobDistCenterOptions, setAddJobDistCenterOptions] = useState([]);

  const columns = [
    { Header: "Distributor Name", accessor: "distributorName" },
    { Header: "Distribution Center", accessor: "distributionCenter" },
    { Header: "Bank Name", accessor: "bankName" },
    { Header: "UploadDate", accessor: "uploadDate" },
  ];

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setfilter({
      distributorId: null,
      distCenterId: null,
      vizId: null,
      financier: null,
      kycStatus: null,
      contractStatus: null,
      fromDate: new Date(),
      toDate: new Date(),
      pageNo: 0,
      searchText: null,
      isExport: false,
    });

    setFilterDistributorName(null);
    setFilterDistributionID(null);
    setAddJobDistCenterOptions([]);
  };

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setSearchText(text);
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    fetchReportData({ ...formRequestObject(), pageNo: page });
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    fetchReportData({ ...formRequestObject(), pageSize });
  };

  const LoadDataByfilter = () => {
    setCurrentPageNo(0);
    fetchReportData({ ...formRequestObject(), pageNo: 0 });
    setShow(false);
  };

  const Download = () => {
    props.downloadJob(formRequestObject(true));
  };

  function formRequestObject(isExport = false) {
    let requestData = {
      distributorId: filterDistributorName?.value ?? null,
      distCenterId: filterDistributionID?.value ?? null,
      vizId: filter.vizId,
      financier: filter.financier?.value,
      kycStatus: filter.kycStatus?.value,
      contractStatus: filter.contractStatus?.value,
      fromDate: formatDate(filter.fromDate),
      toDate: formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText,
      isExport,
    };

    if (userRights?.userType === "DistributorUser" || userRights?.userType === "CoreAppUser") {
      requestData.distributorId = userRights.distributorId;
    }

    return requestData;
  }

  function fetchReportData(request) {
    props.getTransactionalData(request ?? formRequestObject());
  }

  useEffect(() => {
    fetchReportData();
  }, [searchText]);

  useEffect(() => {
    setTotalRecords(props.ShopTransactionalData?.totalRecords ?? 0);
  }, [props.ShopTransactionalData]);

   useEffect(() => {
     props.getDropdownList(
       `api/Distributor/GetDistributorsDDL`,
       GET_DISTRIBUTOR_DDL
     );

     props.getDropdownList(
       `api/DistShopInductionJob/GetDistributorsDDL`,
       GET_JOBS_DISTRIBUTOR_DDL
     );
    
   }, []);

    useEffect(() => {
      if (userRights != null && userRights?.userType == "DistributorUser") {
        let distributorList = props.allDistributorList.filter(
          (x) => x.value == userRights?.distributorId
        );
        setAddJobDistributorsOptions(
          distributorList.map(function (item) {
            return {
              value: item.value,
              label: item.label,
            };
          })
        );
      } else {
        setAddJobDistributorsOptions(
          props.allDistributorList.map(function (item) {
            return {
              value: item.value,
              label: item.label,
            };
          })
        );
      }
    }, [props.allDistributorList]);
  
    useEffect(() => {
      if (userRights != null && userRights?.userType == "DistributorUser") {
        let distCenterList = props.addJobDistCentersddlList.filter((x) =>
          userRights?.distCenterIds.includes(x.value)
        );
        setFilterDistributionCentersOptions(
          distCenterList.map(function (item) {
            return {
              value: item.value,
              label: item.label,
              principalName: item.principalName,
              cityName: item.cityName,
            };
          })
        );
      } else {
        setFilterDistributionCentersOptions(
          props.addJobDistCentersddlList.map(function (item) {
            return {
              value: item.value,
              label: item.label,
              principalName: item.principalName,
              cityName: item.cityName,
            };
          })
        );
      }
    }, [props.addJobDistCentersddlList]);
  
    useEffect(() => {
      if (userRights != null && userRights?.userType == "DistributorUser") {
        let distCenterList = props.distCentersddlList.filter((x) =>
          userRights?.distCenterIds.includes(x.value)
        );
        setAddOrderDistributionCentersOptions(
          distCenterList.map(function (item) {
            return {
              value: item.value,
              label: item.label,
            };
          })
        );
      } else {
        setAddOrderDistributionCentersOptions(
          props.distCentersddlList.map(function (item) {
            return {
              value: item.value,
              label: item.label,
            };
          })
        );
      }
    }, [props.distCentersddlList]);
  
    useEffect(() => {
      if (filterDistributorName) {
        props.getDropdownListByPost(
          `api/DistCenter/GetDistCentersDDL`,
          {distributorIds: filterDistributorName.value} ,
          GET_DISTRIBUTIONCENTER_DDL
        );
      }
    }, [filterDistributorName]);
    useEffect(() => {
      if (addJobDistributorName) {
       props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
          {distributorIds: addJobDistributorName.value} ,
          GET_ADDJOB_DISTRIBUTIONCENTER_DDL
        );
      }
    }, [addJobDistributorName]);

      const fetchBanks = () => {
        props.getDropdownList(`api/Bank/`, GET_BANKS);
      };

  const OpenModelForAddJob = (isOpen) => {
    setJobModalShow(isOpen);
    setAddJobDistributorName(null);
    setAddJobDistributionCenter(null);
    setDataSheetSelectedFile(null);
     if (isOpen) {
        fetchBanks();
      }
  };

  const submitJobData = () => {
    //debugger;
    if (!dataSheetSelectedFile || !addJobDistributorName || !addJobDistributionCenter || !bankNameValue ) {
      toast.error("Please select Data Sheet");
      return;
    }

    props.addTransactionalSheet({
      distributorId: addJobDistributorName.value,
      DistCenterId: addJobDistributionCenter.value,
      bankId: bankNameValue.id,
      DataFile: dataSheetSelectedFile,
      assignedDistCenters: userRights?.distCenterIds,
    });

    setJobModalShow(false);
  };

  const validateDataSheetFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.size > getExcelSize()) {
      toast.error(`Excel size exceed from ${MAX_FILE_SIZE_MB}MB(s)`);
      return;
    }

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      toast.error("Only Excel files allowed");
      return;
    }

    setDataSheetSelectedFile(file);
  };

    const onRowClick = (e, rowData) => {
        if (!rowData) {
            return;
        }
  history.push(`/CustomerDataReport/${rowData.id}`);
};

  return (
          <VzPageContainer title="Shop Transactional Data Report">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Shop Transactional Data Report</b>
            </h4>
            <br />
          </Col>
         
        </Row>

        <Row>
          <Col md={8} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={{}}
                      validator={() => ({})}
                      onSubmit={(e) => LoadDataByfilter(e)}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distributor"
                                name="distributorName"
                                options={addJobDistributorsOptions}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setFilterDistributionID(null);
                                    setFilterDistributorName(null);
                                    return;
                                  }
                                  setFilterDistributorName({
                                    label: e.label,
                                    value: e.value,
                                  });
                                  setFilterDistributionID(null);
                                }}
                                value={filterDistributorName}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distribution Center"
                                name="distCenterId"
                                options={addJobDistCenterOptions}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setFilterDistributionID(null);

                                    return;
                                  }
                                  setFilterDistributionID({
                                    label: e.label,
                                    value: e.value,
                                  });
                                }}
                                value={filterDistributionID}
                              />
                            </Col>
                            <Col xs={12} md={6}>
                              <FormikControl
                                // formik={formik}
                                control="date"
                                label="From Date"
                                name="fromDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, fromDate: value });
                                }}
                                value={filter.fromDate}
                              />
                            </Col>
                            <Col xs={12} md={6}>
                              <FormikControl
                                control="date"
                                label="To Date"
                                name="toDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, toDate: value });
                                }}
                                value={filter.toDate}
                              />
                            </Col>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
          {isPermittedPage("Export", props.actions, props.userRole) && (
            <Col md={2} style={{ textAlign: "end", margintop: "2px" }}>
                <div className="form-group">
              <Button
                onClick={Download}
                variant="outline-primary"
                 style={{ marginLeft: "10px", marginTop: "18px"}}
              >
                <i className="fa fa-download me-1" />
                Export
              </Button>
                </div>
            </Col>
          )}
           {isPermittedPage("add job", props.actions, props.userRole) && (
            <Col md={2}>
              <div className="form-group">
                <Button
                  variant="primary"
                  className="m-3"
                  onClick={() => OpenModelForAddJob(true)}
                >
                  <i className="fa fa-tasks" /> Upload Data
                </Button>
              </div>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <ServerSideDataTable
              data={props.ShopTransactionalData?.data ?? []}
              columns={columns}
               getTrProps={(event, data) => onRowClick(event, data)}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
        <Modal
          show={jobModalShow}
          onHide={() => setJobModalShow(false)}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Upload Transaction Data
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              enableReinitialize
              initialValues={addJobModalInitialValue}
              validationSchema={addJobFormValidationSchema}
              onSubmit={submitJobData}
            >
              {(formik) => (
                <Form
                  autoComplete="off"
                  encType="multipart/form-data"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <Container>
                    <Row>
                      <Col md={{ span: 5 }} style={{ float: "right" }}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            control="react-select"
                            label="Distributor"
                            name="distributorName"
                            options={addJobDistributorsOptions}
                            handleOnChange={(option) => {
                              setAddJobDistributionCenter(null);
                              if (!option || !option.value) {
                                setAddJobDistributorName(null);
                                setAddJobModalInitialValue({
                                  ...addJobModalInitialValue,
                                  distributionCenter: "",
                                  distributorName: "",
                                });
                              } else {
                                setAddJobDistributorName(option);
                                setAddJobModalInitialValue({
                                  ...addJobModalInitialValue,
                                  distributionCenter: "",
                                  distributorName: option.label,
                                });
                              }
                            }}
                            value={addJobDistributorName}
                          />
                        </div>
                      </Col>
                      <Col md={{ span: 7 }} style={{ float: "right" }}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            control="react-select"
                            // isSearchable={true}
                            // isClearable={true}
                            label="Distribution Center"
                            name="distributionCenter"
                            options={filterDistributionCentersOptions}
                            handleOnChange={(option) => {
                              if (!option || !option.value) {
                                setAddJobDistributionCenter(null);
                                addJobModalInitialValue.distributionCenter = "";
                              } else {
                                setAddJobDistributionCenter(option);
                                addJobModalInitialValue.distributionCenter =
                                  option.value;
                              }
                            }}
                            value={addJobDistributionCenter}
                          />
                        </div>
                      </Col>
                      <Col md={{ span: 5 }} style={{ float: "right" }}>
                        <div className="form-group">
                           <FormikControl
                          formik={formik}
                          control="react-select"
                          type="bankName"
                          label="Bank Name"
                          name="bankName"
                          value={bankNameValue}
                          options={props.banks}
                          handleOnChange={(option) => {
                            //debugger;
                              if (!option || !option.id) {
                                setBankNameValue(null);
                                addJobModalInitialValue.bankname = "";
                              } else {
                                setBankNameValue(option);
                                addJobModalInitialValue.bankname =
                                  option.id;
                              }
                            }}
                        />
                        </div>
                      </Col>
                       <Col md={{ span: 7 }}>
                        <div className="form-group">
                            <span>
                              Select Transactional Data Sheet File (Only Excel file)
                            </span>
                            {dataSheetSelectedFile && (
                              <div className="mt-2">
                                <img
                                  style={{ border: "1px solid #ccc" }}
                                  alt="not found"
                                  width={"100px"}
                                  height={"100px"}
                                  src={ExcelIcon}
                                />
                                <br />
                                <button
                                  className="btn btn-info"
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "10px",
                                    marginBottom: "20px",
                                  }}
                                  onClick={() => {
                                    addJobModalInitialValue.jobDataFile = null;
                                    setDataSheetSelectedFile(null);
                                  }}
                                >
                                  <i className="fa fa-close" />
                                  Remove
                                </button>
                              </div>
                            )}
                            {!dataSheetSelectedFile && (
                              <div className="mt-2">
                                <input
                                  type="file"
                                  name="dataSheetSelectedFile"
                                  onChange={(event) =>
                                    validateDataSheetFile(event)
                                  }
                                />
                                </div>
                            )}
                          </div>
                      </Col>
                    </Row>
                    <Row>
                     
                    </Row>
                    <Row>
                      <Col xs={12} md={{ span: 5 }}></Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12}>
                        <Button
                          className="btn btn-default"
                          style={{ float: "right", marginTop: "10px" }}
                          onClick={() => setJobModalShow(false)}
                        >
                          Cancel
                        </Button>
                        <input
                          type="submit"
                          className="btn btn-primary"
                          style={{
                            marginRight: "10px",
                            marginTop: "10px",
                            float: "right",
                          }}
                          value="Save File"
                        />

                        <a
                          href={`${TransactionalDataFileTemplate}`}
                          download="TransactionalDataTemplateFile"
                          className="active"
                          style={{
                            padding: "0px",
                            marginTop: "20px",
                            float: "left",
                          }}
                        >
                          Download Template
                        </a>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>
      </VzPageContainer>
  );
};

const mapStateToProps = (state) => ({
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    filteredDistributorList: state.ddlList.filteredDistributorList
      ? state.ddlList.filteredDistributorList
      : [],
    distCentersddlList: state.ddlList.selectedDistCentersList
      ? state.ddlList.selectedDistCentersList
      : [],
    addJobDistCentersddlList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
  ShopTransactionalData: state.ShopTransactionalData,
    banks: state.ddlList.banks ? state.ddlList.banks : [],
});

export default connect(mapStateToProps, {
  getDropdownList,
  addTransactionalSheet,
  getTransactionalData,
  getDropdownListByPost,
  downloadJob,
})(ShopTransactionalData);
